



































































import { Component, Vue } from 'vue-property-decorator';
import { Fragment } from 'vue-fragment';

import { DispatchModule } from '@/store/index';
import ExportFilters from '../ExportFilters/ExportFilters.vue';
import { DispatchType } from '../../models/dispatch.model';
import { DispatchService } from '@/shared/services/dispatch/dispatch.service';
import { MasterDataService } from '../../../../shared/services/mater-data/master-data.service';
import { ToastHelper } from '@/utils/toast.util';
import {
  BS_DATEPICKER_WITH_TIME,
  convertDateFieldToAPIFormat,
  convertAPIToFormat,
  convertAPIToViewFullFormat
} from '@/utils/date.util';
import WoBaseModal from '@/pages/Main/components/WoBaseModal.vue';
import Loading from '@/shared/components/Loading.vue';
import {
  ValidationService,
  stringCommonRule
} from '@/shared/services/validation/validation.service';
import DriverIdModal from '@/shared/components/modal/DriverIdModal.vue';
import DriverInputWrapper from '@/shared/components/form/DriverInputWrapper.vue';
import {
  DispatchScheduleLocation,
  LocationType
} from '@/shared/models/woSchedule.model';
import { JobPayments } from '@/shared/models/driverIdModal.model';
import { JobsService } from '@/shared/services/jobs/jobs.service';
import { isClickedOnInput } from '@/shared/models/wo.model';
import {
  DeliveryCategoriesHeaders,
  DeliveryTableHeaders
} from '../models/tables/delivery';
import TmsTable from '@/shared/components/table/TmsTable.vue';
import { getRowSchedules } from '../../utils/get-row-schedules';
import {
  getScheduleLocationErrors,
  getScheduleOrderErrors
} from '@/shared/services/wo/schedule-validation';
import { PermissionsService } from '@/shared/services/permission/permission.service';
import { AdminConfService } from '@/shared/services/admin-conf/admin-conf.service';

@Component({
  components: {
    Fragment,
    ExportFilters,
    WoBaseModal,
    Loading,
    DriverIdModal,
    DriverInputWrapper,
    TmsTable
  }
})
export default class Delivery extends Vue {
  convertAPIToFormat = convertAPIToFormat;
  convertAPIToViewFullFormat = convertAPIToViewFullFormat;
  dispatchModule = DispatchModule;
  masterDataService = MasterDataService;

  tabIndex = 0;
  contextMenuOptions = [
    {
      name: this.$i18n.t('contextMenu.detailInfo'),
      slug: 'detail-info-modal',
      index: 0
    },
    {
      name: this.$i18n.t('contextMenu.billingInfo'),
      slug: 'billing-info-modal',
      index: 1
    },
    {
      name: this.$i18n.t('contextMenu.document'),
      slug: 'document-modal',
      index: 2
    },
    {
      name: this.$i18n.t('contextMenu.memo'),
      slug: 'memo-modal',
      index: 3
    },
    {
      name: this.$i18n.t('contextMenu.tracking'),
      slug: 'tracking-modal',
      index: 4
    }
  ];

  LocationType = LocationType;
  woModalId = 'wo-base-modal';

  tableKey = true;
  loading = false;
  search = null;
  scheduleClickedIndex: number = null;
  driverClickedName: string = null;
  currentPage = 1;
  routeName = 'export';
  selectedWo = {};
  categoryTableHeaders = DeliveryCategoriesHeaders;
  columnHeaders = DeliveryTableHeaders(AdminConfService.chassisPool);
  isShown = {
    eq: true,
    info: true,
    book: true,
    loc: true,
    geo: true,
    sched: true
  };
  options = {
    pool: [
      { value: 'POOL', text: 'POOL' },
      { value: 'NGL', text: 'NGL' },
      { value: 'AIM', text: 'AIM' },
      { value: 'APL', text: 'APL' },
      { value: 'CS', text: 'CHINASHIPPING' },
      { value: 'CSNA', text: 'CSNA' },
      { value: 'DCLI', text: 'DCLI' },
      { value: 'EG', text: 'EVERGREEN' },
      { value: 'FLEXI', text: 'FLEXI' },
      { value: 'TNWA', text: 'TNWA' },
      { value: 'POP', text: 'POP' },
      { value: 'HD', text: 'HD' },
      { value: 'LABP', text: 'LABP' },
      { value: 'MTSN', text: 'MATSON' },
      { value: 'TAXZ', text: 'TAXZ' },
      { value: 'WCCP', text: 'WCCP' },
      { value: 'YM', text: 'YANGMING' },
      { value: 'GCCP', text: 'GCCP' },
      { value: 'GACP', text: 'GACP' },
      { value: 'KLINE', text: 'K-LINE' },
      { value: 'MOL', text: 'MOL' },
      { value: 'TPSP', text: 'TPSP' },
      { value: 'SEA', text: 'SEALAND' }
    ],
    liveDrp: [
      { value: 'SELECT', text: 'Select' },
      { value: 'DROP', text: 'Drop' },
      { value: 'LIVE', text: 'Live' }
    ]
  };

  activeItem = null;
  activeItemOrderNumber = null;
  jobPayments: JobPayments = null;

  validationRules = {
    chassisNumber: [{ name: 'regular', value: '^[a-zA-Z]{4}[0-9]{6}$' }],
    dropLive: [...stringCommonRule]
  };
  validationService = new ValidationService(this.validationRules);
  disabled = false;
  constructor() {
    super();
  }

  created() {
    this.disabled = PermissionsService.can(
      'DSP / MAIN / BC DETAIL',
      'EXP',
      'View'
    );
  }

  openDetailModal(selectedData, index, event?) {
    if (event && isClickedOnInput(event)) {
      return;
    }
    this.selectedWo = selectedData;
    this.tabIndex = index;
    this.$bvModal.show('wo-base-modal');
  }

  rowRightClicked(item: any, index, event) {
    event.preventDefault();
    const contextMenu: any = this.$refs.contextMenu;
    contextMenu.showMenu(event, item);
  }

  get editableData() {
    return this.dispatchModule.dispatches;
  }

  get isLastPage(): boolean {
    return !this.dispatchModule.meta.lastKey;
  }

  onAction({ key, data }: { key: string; data: any }) {
    switch (key) {
      case 'save':
        this.checkJobPayments(data);
        break;
      case 'chassisPool':
      case 'dropLive':
        break;
      default:
        this.openDetailModal(data, 0);
    }
  }

  onContextMenuOptionSelect(event: {
    item: any;
    option: { name: string; slug: string; index: number };
  }) {
    this.openDetailModal(event.item, event.option.index);
  }

  async onPaginationChange() {
    await this.dispatchModule.search({
      dispatchType: DispatchType[this.routeName.substr(0, 3).toUpperCase()],
      category: this.$route.name.replace(`${this.routeName}-`, '')
    });
  }

  validateItem(item: any, itemName: string) {
    return this.validationService.checkItemValidity(item, itemName);
  }

  validationClass(item: any, itemName: string) {
    return this.validationService.validationClass(item, itemName);
  }

  changeIsShownHandler(param) {
    this.isShown[param] = !this.isShown[param];
  }

  async checkJobPayments(item) {
    this.activeItem = item;

    const editedSchedules = getRowSchedules(item);

    const datesOrderErrors = getScheduleOrderErrors(editedSchedules);
    if (datesOrderErrors.length) {
      ToastHelper.show('Error', datesOrderErrors[0], 5000, 'danger');
      return;
    }

    this.save({
      jobPayments: item.jobPayments,
      schedules: editedSchedules
    });
  }

  async save({ jobPayments, schedules }) {
    this.$bvModal.hide('DriverIdModal');

    !this.activeItem.chassisNumber
      ? (this.activeItem.chassisNumber = null)
      : '';

    if (this.validationService.checkAllItemsValidity(this.activeItem)) {
      this.loading = true;

      try {
        await DispatchService.saveRequest(
          DispatchType[this.routeName.substr(0, 3).toUpperCase()],
          this.$route.name.replace(`${this.routeName}-`, ''),
          this.activeItem.orderNumber,
          {
            chassisNumber: this.activeItem.chassisNumber,
            chassisPool: this.activeItem.chassisPool,
            dropLive: this.activeItem.dropLive,
            remarks: this.activeItem.remarks,
            jobPayments,
            schedules
          }
        );
        ToastHelper.show(
          `${this.routeName}/${this.$route.name.replace(
            `${this.routeName}-`,
            ''
          )}`,
          'Save successful',
          5000,
          'success'
        );
      } catch (err) {
        ToastHelper.show(
          `${this.routeName}/${this.$route.name.replace(
            `${this.routeName}-`,
            ''
          )}`,
          err.message,
          5000,
          'danger'
        );
      }

      this.loading = false;
      this.tableKey = !this.tableKey;
    } else {
      console.log('error!');
    }
  }

  rowClass(item) {
    if (!item) return;

    if ((item.cfFile && item.cfsFile) || item.cfFile) {
      return 'light-red-row';
    } else if (item.cfsFile) {
      return 'green-row';
    }
  }

  async seach() {
    try {
      await DispatchModule.search({
        dispatchType: DispatchType[this.routeName.substr(0, 3).toUpperCase()],
        category: this.$route.name.replace(`${this.routeName}-`, '')
      });
    } catch (err) {
      ToastHelper.show(
        `${this.routeName}/${this.$route.name.replace(
          `${this.routeName}-`,
          ''
        )}`,
        err.message,
        5000,
        'danger'
      );
    }
  }
}
